import axios from "axios";

const api = axios.create({
  baseURL: 'https://intranet.microrredes.org.br/api/'
});

export default api;
